import { Navigate } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import CircuitCalendar from "../pages/circuits/CircuitCalendar";
import PostViewer from "../pages/cms/PostViewer";
import EventCalendar from "../pages/events/EventCalendar";
import EventHome from "../pages/events/EventHome";
import EventJudgeReport from "../pages/events/EventJudgeReport";
import EventPlacingsTruncated from "../pages/events/EventPlacingsTruncated";
import EventRegistration from "../pages/events/EventRegistration";
import Events from "../pages/events/Events";
import EventsPlay from "../pages/events/EventsPlay";
import GroupCountryDetails from "../pages/events/groupPlay/GroupCountryDetails";
import GroupMedals from "../pages/events/groupPlay/GroupMedals";
import GroupPlayerDetails from "../pages/events/groupPlay/GroupPlayerDetails";
import GroupSummary from "../pages/events/groupPlay/GroupSummary";
import Home from "../pages/home/Home";
import ArmyListSearchOld from "../pages/lists/ArmyListSearchOld";
import SubmitList from "../pages/lists/SubmitList";
import OrganizationLanding from "../pages/organizations/OrganizationLanding";
import OrganizationSearch from "../pages/organizations/OrganizationSearch";
import OrganizationTruncatedRankings from "../pages/rankings/OrganizationTruncatedRankings";
import Eula from "../pages/static/Eula";
import FindUs from "../pages/static/FindUs";
import Pricing from "../pages/static/Pricing";
import Privacy from "../pages/static/Privacy";
import VerifyInfo from "../pages/static/VerifyInfo";
import StripeConfirmation from "../pages/stripe/StripeConfirmation";
import TeamProfile from "../pages/teams/TeamProfile";
import PurchaseConfirmation from "../pages/transactions/PurchaseConfirmation";
import LogOut from "../pages/user/LogOut";
import Login from "../pages/user/Login";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import OAuth2IDResponse from "../pages/user/OAuth2IDResponse/OAuth2IDResponse";
import Profile from "../pages/user/Profile";
import Unsubscribe from "../pages/user/Unsubscribe";
import AccessDenied from "../pages/utility/AccessDenied";
import CognitoVerification from "../pages/utility/CognitoVerification";
import NotFound from "../pages/utility/NotFound";
import Support from "../pages/utility/Support";
import Theming from "../pages/utility/Theming";
import ArmyListSearch from "../pages/lists/ArmyListSearch";
import ArmyListBuilderView from "../pages/lists/ArmyListBuilderView";
import ArmyList from "../pages/lists/ArmyList";
import ArmyListBuilder from "../pages/lists/ArmyListBuilder";
import Cards from "../pages/cards/Cards";
import Card from "../pages/cards/Card";
import GameRouter from "../pages/pairings/GameRouter";
import Games from "../pages/events/Games";
import StatsDashboard from "../pages/stats/StatsDashboard";
import OrganizationRegister from "../pages/organizations/OrganizationRegister";
import { getEnvironmentVariable } from "../global/environmentVariables";
import { rootRankingsRoutes } from "./RankingsRoutes";
import { rootSubscriptionRoutes } from "./SubscriptionRoutes";
import { isAppMode } from "../global/AppOverlay";
import SubscriptionNotice from "../pages/subscription/SubscriptionNotice";
import ComingSoonPage from "../pages/utility/ComingSoonPage";
import SoftScoreScorecard from "../pages/pairings/SoftScoreScorecard";
import CookieNotice from "../pages/static/CookieNotice";
import StreamOverlayCatan from "../pages/stream/StreamOverlayCatan";
import SquareConfirmation from "../pages/square/SquareConfirmation";
import SquareDetails from "../pages/square/SquareDetails";
import { EventPrintPairings } from "../pages/events/printing/EventPrintPairings";
import BetaTestFeatures from "../pages/user/BetaTestFeatures";
import SubscriptionInfo from "../pages/subscription/SubscriptionInfo";
import WarhammerYear2025LandingPage from "../pages/other/WarhammerYear2025LandingPage";

const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";
const IS_DEV = getEnvironmentVariable("IS_DEV") === "true";
const IS_BCP = getEnvironmentVariable("IS_BCP") === "true";
const SUPPORTS_CMS = getEnvironmentVariable("SUPPORTS_CMS") === "true";
const IS_UY = getEnvironmentVariable("IS_UY") === "true";
const SUPPORTS_CARD_DATABASE =
  getEnvironmentVariable("SUPPORTS_CARD_DATABASE") === "true";

export const rootRoutes = (
  authContext,
  itemsMiddle,
  setItemsMiddle,
  eventObject,
  setEventObject
) => {
  const forceLoginParam = findGetParameter("forceLogin");
  const appMode = isAppMode();

  let _children = [
    { path: "/", element: <Home /> },
    { path: "home", element: <Home /> },

    { path: "oauth2/idresponse", element: <OAuth2IDResponse /> },

    {
      path: "truncated",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "event/:eventId",
          element: <EventPlacingsTruncated />
        },

        { path: "*", element: <NotFound /> }
      ]
    },

    {
      path: "forgotpassword",
      element: <Login defaultStep="sendforgotcode" />
    },
    {
      path: "forgotpassword/*",
      element: <Login defaultStep="sendforgotcode" />
    },
    { path: "signup", element: <Login defaultStep="signup" /> },
    { path: "events", element: <Events /> },
    { path: "calendar/:leagueId", element: <EventCalendar /> },

    { path: "organizations", element: <OrganizationSearch /> },
    {
      path: "store-finder",
      element: <OrganizationSearch organizationType="store" />
    },
    {
      path: "club-finder",
      element: <OrganizationSearch organizationType="club" />
    },

    {
      path: "my-events",
      element: authContext?.authState?.isAuthenticated ? (
        <EventsPlay />
      ) : (
        <LoginRedirect />
      )
    },

    {
      path: "event/:eventId",
      element: <EventHome />
    },
    {
      path: "event/:eventId/judge-report",
      element: <EventJudgeReport />
    },
    {
      path: "event/:eventId/reports",
      element: <EventPrintPairings />
    },
    {
      path: "event/:eventId/register",
      element: <EventRegistration />
    },

    {
      path: "bcpevent/:eventId",
      element: <EventHome />
    }, // route from historic routes
    {
      path: "eventlanding/:eventId",
      element: <EventHome />
    }, // route from historic routes

    {
      path: "list-search-old",
      element:
        NO_SUBSCRIPTIONS ||
        authContext?.authState?.identity?.subscriber ||
        authContext?.authState?.identity?.isAdmin === true ? (
          <ArmyListSearchOld />
        ) : !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <Navigate to="/subscription?subFeature=true" />
        )
    },
    {
      path: "list-search",
      element:
        NO_SUBSCRIPTIONS ||
        authContext?.authState?.identity?.subscriber ||
        authContext?.authState?.identity?.isAdmin === true ? (
          <ArmyListSearch />
        ) : NO_SUBSCRIPTIONS ||
          authContext?.authState?.identity?.subscriber ||
          authContext?.authState?.identity?.isAdmin === true ? (
          <ArmyListSearch />
        ) : !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : appMode ? (
          <SubscriptionNotice />
        ) : (
          <Navigate to="/subscription?subFeature=true" />
        )
    },
    {
      path: "spell-book-search",
      element:
        NO_SUBSCRIPTIONS ||
        authContext?.authState?.identity?.subscriber ||
        authContext?.authState?.identity?.isAdmin === true ? (
          <ArmyListSearch />
        ) : !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : appMode ? (
          <SubscriptionNotice />
        ) : (
          <Navigate to="/subscription?subFeature=true" />
        )
    },
    {
      path: "deck-search",
      element:
        SUPPORTS_CARD_DATABASE &&
        (NO_SUBSCRIPTIONS ||
          authContext?.authState?.identity?.subscriber ||
          authContext?.authState?.identity?.isAdmin === true) ? (
          <ArmyListSearch />
        ) : NO_SUBSCRIPTIONS ||
          authContext?.authState?.identity?.subscriber ||
          authContext?.authState?.identity?.isAdmin === true ? (
          <ArmyListSearch />
        ) : !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : appMode ? (
          <SubscriptionNotice />
        ) : (
          <Navigate to="/subscription?subFeature=true" />
        )
    },

    {
      path: "list/:armyListId",
      element: authContext?.authState?.isAuthenticated ? (
        <ArmyList setEvent={setEventObject} />
      ) : (
        <LoginRedirect />
      )
    },
    {
      path: "deck/:armyListId",
      element: authContext?.authState?.isAuthenticated ? (
        SUPPORTS_CARD_DATABASE ? (
          <ArmyListBuilderView setEvent={setEventObject} />
        ) : (
          <ArmyList setEvent={setEventObject} />
        )
      ) : (
        <LoginRedirect />
      )
    },
    {
      path: "spell-book/:armyListId",
      element: authContext?.authState?.isAuthenticated ? (
        <ArmyList setEvent={setEventObject} />
      ) : (
        <LoginRedirect />
      )
    },
    {
      path: "deck/:armyListId", // TODO: correct once deck builder live
      element: authContext?.authState?.isAuthenticated ? (
        // TODO: Deck Builder
        authContext?.authState?.identity?.isAdmin === true || IS_DEV ? (
          <ArmyListBuilderView setEvent={setEventObject} />
        ) : (
          <ArmyList setEvent={setEventObject} />
        )
      ) : (
        <LoginRedirect />
      )
    },

    {
      path: "legacy/list/:armyListId",
      element: authContext?.authState?.isAuthenticated ? (
        <ArmyList setEvent={setEventObject} />
      ) : (
        <LoginRedirect />
      )
    },
    {
      path: "stream/:pairingId",
      element: <StreamOverlayCatan />
    }
  ];

  if (SUPPORTS_CARD_DATABASE) {
    _children.push(
      {
        path: "deck-builder",
        element: authContext?.authState?.isAuthenticated ? (
          <ArmyListBuilder heading="Deck Builder" />
        ) : (
          <LoginRedirect />
        )
      },
      {
        path: "deck/:deckId/deck-builder",
        element: authContext?.authState?.isAuthenticated ? (
          <ArmyListBuilder heading="Deck Builder" />
        ) : (
          <LoginRedirect />
        )
      },
      {
        path: "cards",
        element: <Cards />
      },
      {
        path: "card/:cardId",
        element: <Card />
      }
    );
  }

  _children.push(
    {
      path: "game/jwt", // used for legacy php site routing
      element: (
        <GameRouter setEvent={setEventObject} setItemsMiddle={setItemsMiddle} />
      )
    },
    {
      path: "game/:pairingType/:objectId",
      element: (
        <GameRouter setEvent={setEventObject} setItemsMiddle={setItemsMiddle} />
      )
    },
    {
      path: "softscore/:softScoreId/:playerId",
      element: (
        <SoftScoreScorecard
          event={eventObject}
          setEvent={setEventObject}
          setItemsMiddle={setItemsMiddle}
        />
      )
    },
    { path: "game", element: <NotFound /> },

    {
      path: "games",
      element: authContext?.authState?.isAuthenticated ? (
        <Games />
      ) : (
        <LoginRedirect />
      )
    },
    {
      path: "stats",
      element: authContext?.authState?.isAuthenticated ? (
        <StatsDashboard />
      ) : (
        <LoginRedirect />
      )
    }
  );

  if (getEnvironmentVariable("DEFAULT_ITC_AOS_LEAGUE_ID")) {
    _children.push({
      path: "aosevents",
      element: (
        <EventCalendar
          submitted
          leagueId={getEnvironmentVariable("DEFAULT_ITC_AOS_LEAGUE_ID")}
        />
      )
    });
  }
  if (getEnvironmentVariable("DEFAULT_ITC_AOS_HOBBY_LEAGUE_ID")) {
    _children.push({
      path: "aoshobbyevents",
      element: (
        <EventCalendar
          submitted
          leagueId={getEnvironmentVariable("DEFAULT_ITC_AOS_HOBBY_LEAGUE_ID")}
        />
      )
    });
  }
  if (getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")) {
    _children.push({
      path: "itcevents",
      element: (
        <EventCalendar
          submitted
          leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_LEAGUE_ID")}
        />
      )
    });
  }
  if (getEnvironmentVariable("DEFAULT_ITC_40K_HOBBY_LEAGUE_ID")) {
    _children.push({
      path: "itchobbyevents",
      element: (
        <EventCalendar
          submitted
          leagueId={getEnvironmentVariable("DEFAULT_ITC_40K_HOBBY_LEAGUE_ID")}
        />
      )
    });
  }
  if (getEnvironmentVariable("DEFAULT_ITC_SHADESPIRE_LEAGUE_ID")) {
    _children.push({
      path: "shadespireevents",
      element: (
        <EventCalendar
          submitted
          leagueId={getEnvironmentVariable("DEFAULT_ITC_SHADESPIRE_LEAGUE_ID")}
        />
      )
    });
  }
  if (getEnvironmentVariable("DEFAULT_ITC_KILL_TEAM_LEAGUE_ID")) {
    _children.push({
      path: "killteamevents",
      element: (
        <EventCalendar
          submitted
          leagueId={getEnvironmentVariable("DEFAULT_ITC_KILL_TEAM_LEAGUE_ID")}
        />
      )
    });
  }

  _children.push(
    {
      path: "store/register",
      element: <OrganizationRegister organizationType="store" />
    },

    // route from historic routes
    {
      path: "storelanding/:organizationId", // route from historic routes
      element: <OrganizationLanding />
    },
    {
      path: "storerankings/:organizationId", // route from historic routes
      element: <OrganizationTruncatedRankings />
    },
    {
      path: "storepage/:organizationId", // route from historic routes
      element: <Events />
    },
    { path: "circuit/:leagueId/calendar", element: <CircuitCalendar /> },

    {
      path: "user/:userId",
      element:
        IS_UY &&
        !authContext?.authState?.identity?.isAdmin === true &&
        !authContext?.authState?.identity?.subscriber ? (
          <ComingSoonPage />
        ) : (
          <Profile />
        )
    },
    {
      path: "bcpuser/:userId",
      element:
        IS_UY &&
        !authContext?.authState?.identity?.isAdmin === true &&
        !authContext?.authState?.identity?.subscriber ? (
          <ComingSoonPage />
        ) : (
          <Profile />
        )
    },
    { path: "bcpuser", element: <NotFound /> },
    { path: "user", element: <NotFound /> },

    {
      path: "team/:teamId",
      element:
        IS_UY &&
        !authContext?.authState?.identity?.isAdmin === true &&
        !authContext?.authState?.identity?.subscriber ? (
          <ComingSoonPage />
        ) : (
          <TeamProfile />
        )
    },
    {
      path: "bcpteam/:teamId",
      element:
        IS_UY &&
        !authContext?.authState?.identity?.isAdmin === true &&
        !authContext?.authState?.identity?.subscriber ? (
          <ComingSoonPage />
        ) : (
          <TeamProfile />
        )
    }, // route from historic routes
    { path: "team", element: <NotFound /> },
    { path: "bcpteam", element: <NotFound /> },

    {
      path: "transaction/:transactionId/receipt",
      element: <PurchaseConfirmation />
    },
    { path: "submitlist/:playerId", element: <SubmitList /> }, // route from historic routes: PlayerId is the ####-####-####-####

    { path: "stripe/account-creation", element: <StripeConfirmation /> },
    { path: "stripe-account", element: <StripeConfirmation /> },

    { path: "square/callback", element: <SquareConfirmation /> },
    { path: "square-account", element: <SquareDetails /> },

    {
      path: "notifications/unsubscribe",
      element: <Unsubscribe />
    },

    // static pages
    { path: "pricing", element: <Pricing /> },
    { path: "support", element: <Support /> },
    { path: "eula", element: <Eula /> },
    { path: "terms", element: <Eula /> },
    { path: "privacy", element: <Privacy /> },
    { path: "cookies", element: <CookieNotice /> },
    { path: "data-collection", element: <VerifyInfo /> },

    { path: "theme", element: <Theming /> },
    { path: "cognito-verification", element: <CognitoVerification /> },

    { path: "access-denied", element: <AccessDenied /> },

    {
      path: "find-us",
      element: IS_BCP ? <FindUs /> : <PostViewer />
    },
    {
      path: "betaTestFeatures",
      element: IS_BCP ? <BetaTestFeatures /> : <NotFound />
    },
    {
      path: "sub-info",
      element: IS_BCP ? <SubscriptionInfo /> : <NotFound />
    },
    {
      path: "year-of-warhammer-2025",
      element: IS_BCP ? <WarhammerYear2025LandingPage /> : <NotFound />
    }
  );

  if (IS_BCP) {
    _children.push(
      {
        path: "world-championships-of-warhammer",
        element: <GroupSummary label="World Championships of Warhammer" />
      },
      {
        path: "world-championships-of-warhammer/players",
        element: <GroupPlayerDetails label="World Championships of Warhammer" />
      },
      {
        path: "world-championships-of-warhammer/countries",
        element: (
          <GroupCountryDetails label="World Championships of Warhammer" />
        )
      },
      {
        path: "world-championships-of-warhammer/medals",
        element: <GroupMedals label="World Championships of Warhammer" />
      }
    );
    let gwyears = ["23", "24", "25"];
    for (let gwyear of gwyears) {
      _children.push(
        {
          path: `world-championships-of-warhammer-${gwyear}`,
          element: (
            <GroupSummary
              label="World Championships of Warhammer"
              eventGroupId={`WorldChamps${gwyear}`}
            />
          )
        },
        {
          path: `world-championships-of-warhammer-${gwyear}/players`,
          element: (
            <GroupPlayerDetails
              label="World Championships of Warhammer"
              eventGroupId={`WorldChamps${gwyear}`}
            />
          )
        },
        {
          path: `world-championships-of-warhammer-${gwyear}/countries`,
          element: (
            <GroupCountryDetails
              label="World Championships of Warhammer"
              eventGroupId={`WorldChamps${gwyear}`}
            />
          )
        },
        {
          path: `world-championships-of-warhammer-${gwyear}/medals`,
          element: (
            <GroupMedals
              label="World Championships of Warhammer"
              eventGroupId={`WorldChamps${gwyear}`}
            />
          )
        }
      );
    }
  }
  _children.push(...rootRankingsRoutes(), ...rootSubscriptionRoutes());

  if (SUPPORTS_CMS) {
    _children.push({ path: ":postId", element: <PostViewer /> });
  }

  _children.push({ path: "*", element: <NotFound /> });

  return [
    { path: "login", element: <Login /> },
    { path: "logout", element: <LogOut /> },
    {
      path: "/",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: _children
    }
  ];
};
